<template>
	<div>
		<div class="cont">
			<Breadcrumb :pathList='pathList'></Breadcrumb>
			<div class="infoItem">
				<div class="flex flex-b">
					<div class="flex">
						<img :src="detail.icon" alt="" style="width: 24px;height: 24px;" />
						<div class="tit">{{detail.title}}</div>
					</div>
					<div class="time">{{detail.create_time}}</div>
				</div>
				<div class="det" v-html="detail.content"></div>
				<div class="flex flex-c-c" @click="toUrl(detail.url_type)" v-if="detail.url_type!=4">
					<div class="login-btn pointer">
						<span class="text">前往查看</span>
					</div>
				</div>
			</div>
		</div>
		<toTop></toTop>
		<Footer ref="footerRef"></Footer>
	</div>
</template>

<script>
	import {
		getMyMessageList,
		getMyMessageDetail
	} from '@/api/mine';
	import Breadcrumb from '../../components/Breadcrumb.vue'
	import toTop from '../../components/toTop.vue'
	import Footer from '../../components/Footer.vue'
	export default {
		data() {
			return {
				pathList: [{
						title: '我的',
						path: '/mine'
					},
					{
						title: '消息通知',
						path: '/message'
					},
					{
						title: '消息详情',
						path: ''
					}
				],
				detail: ''
			}
		},
		mounted() {
			this.getMyMessageDetail()
		},
		methods: {
			toUrl(urlType) {
				//1=课程详情 2=培训详情 3=我的课程列表 4=评论详情 5=我的培训详情 6=我的课程订单 7=会员中心 8=我的课程-详情
				if (urlType == 1 || urlType == 8) {
					this.$router.push({
						path: '/courseDetail',
						query: {
							id: this.detail.course.uuid,
							course_cate_name: this.detail.course.course_cate_name
						}
					})
				}
				if (urlType == 2) {
					this.$router.push({
						path: '/trainingDetail',
						query: {
							id: this.detail.train.uuid,
						}
					})
				}
				if (urlType == 3) {
					this.$router.push({
						path: '/mine',
					})
				}
				if (urlType == 5) {
					this.$router.push({
						path: '/myTraining',
					})
				}
				if (urlType == 6) {
					this.$router.push({
						path: '/mine',
					})
				}
				if (urlType == 7) {
					this.$refs.footerRef.toMemberCenter()
				}
			},
			async getMyMessageDetail() {
				const {
					status,
					data
				} = await getMyMessageDetail({
					uuid: this.$route.query.id
				})
				let obj = {
					...data.result,
					icon: '',
					tit: ''
				}
				if (data.result.type == 1) {
					//系统通知
					obj.icon = require('../../assets/images/mine/icInfo1.png')
					obj.tit = '系统通知'
				}
				if (data.result.type == 2) {
					//评论审核通知
					obj.icon = require('../../assets/images/mine/icInfo2.png')
					obj.tit = '评论审核通知'
				}
				if (data.result.type == 3) {
					//报名成功通知
					obj.icon = require('../../assets/images/mine/icInfo3.png')
					obj.tit = '报名成功通知'
				}
				if (data.result.type == 4) {
					//课程通知
					obj.icon = require('../../assets/images/mine/icInfo4.png')
					obj.tit = '课程通知'
				}
				if (data.result.type == 5) {
					//会员通知
					obj.icon = require('../../assets/images/mine/icInfo5.png')
					obj.tit = '会员通知'
				}
				this.detail = obj
			}
		},
		components: {
			Breadcrumb,
			toTop,
			Footer
		}
	}
</script>

<style lang="less" scoped>
	.cont {
		padding: 30px 133px 0;
		min-height: 100vh;

		.infoItem {
			padding: 20px 0;
			margin: 20px 0;

			.tit {
				margin-left: 10px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 500;
				font-size: 16px;
				color: #000000;
			}

			.time {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #999999;
			}

			.det {
				margin-top: 16px;
				padding-top: 16px;
				border-top: 1px solid #EEEEEE;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 18px;
				color: #000000;
			}

			.t {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #666666;
			}
		}
	}

	.login-btn {
		margin-top: 280px;
		width: 364px;
		height: 59px;
		background: url('../../assets/images/login/loginbtn.png') no-repeat;
		background-size: 100% 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		.text {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 600;
			font-size: 16px;
			text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
			text-align: center;
			font-style: normal;
			text-transform: none;
			background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}
</style>